import { ReactComponent as ManagementLiabilitySVG } from '../../../assets/images/icons/product_icons/management_liability_package_icon.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const ManagementLiabilityIcon = (props: any) => {
    return (
        <SvgIcon {...props} component={ManagementLiabilitySVG} inheritViewBox />
        // <SvgIcon {...props}>
        //     <ManagementLiabilitySVG />
        // </SvgIcon>
    );
};

export default ManagementLiabilityIcon;